// extracted by mini-css-extract-plugin
export default {"container":"cXUO1N_tS","submitButtonIcon":"cbhtntWnP","clearFieldButton":"coa5MAPPj","domainNameInput":"cHBpCThcF"};